export default "__VITE_ASSET__8cf061b5__"